import { ElementRef, Injectable } from '@angular/core';
import { PlycaDataService } from '../../../../services/plyca.service';
import { HelpDTO, ContextHelp, HelpElementDTO, HelpElementType } from './help.dtos';
import { HelpElementResultComponent } from './helpElementResult.component';
import { EMPTY, forkJoin, Observable, of, Subscription } from 'rxjs';
import { AppState } from '../../../store/AppState';
import { Store } from '@ngrx/store';
import { Configuration } from '../../../conf/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../../../ServiceLocator';
import {
  TaskDTO,
  getSimpleIdentifierFromString
} from '../../../api/plyca-dtos';
import { map, take, finalize, catchError, tap } from 'rxjs/operators';
import { UIService } from '../../../ui.service';
import { UserService } from '../../../user.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { WaitLoadingService } from '../waitLoading/wait-loading.service';

import { BaseDirectiveObject } from '../base-directive-object';
import { SET_CONTEXTHELP, DELETE_CONTEXTHELP } from '../../../store/contextHelpReducer';

export class HelpType {
  static EDIT_ORG_COLEGIADO = 'EDIT_ORG_COLEGIADO';
  static EDIT_SOBRE_ELEC = 'EDIT_SOBRE_ELEC';
  static EDIT_DOC_SOBRE = 'EDIT_DOC_SOBRE';
  static EDIT_FASE_LIC = 'EDIT_FASE_LIC';
  static EDIT_EVENTO_APER = 'EDIT_EVENTO_APER';
  static EDIT_FORMULA_CRIT = 'EDIT_FORMULA_CRIT';
  static EDIT_ADJUDICACION = 'EDIT_ADJUDICACION';
  static CREAR_ADJUDICACION = 'CREAR_ADJUDICACION';
  static EXP_BUSCAR = 'EXP_BUSCAR';
  static EXP_CONFIG_VIEW = 'CONFIG_PANTALLA';

  static VALIDATE_SIGN = 'VAL_FIRMA';

  static SEL_DIV = 'SEL_DIV';

  static ADD_PROCEDURE = 'ALTA_TRAMITE';

  static ADD_DOCUMENT = 'CREA_DOC'

  static NEW_TEMPLATE = 'CREA_MODELO_PLANTILLA'

  static CREATE_MODEL = 'CREA_MODELO';

  static NEW_CONTRACT = 'CREACION_CONTRATO';

  static NEW_CONTRACTMODIFICATION = 'CREACION_INCIDENCIA';

  static NEW_REGISTER_CONTRACTMODIFICATION = 'CREACION_INCIDENCIA_RECO';

  static MODEL_DOSSIER_CONTROL_PANEL = 'PANEL_CONTROL_MODELOS_EXPEDIENTE';

  // Mantener despachar tarea
  static OPC_TAREA = 'OPC_TAREA';

  // Mantener despachar firma
  static DEVOL_FIRMA = 'DEVOL_FIRMA';

  // Ver documento
  static VER_DOCUMENTO = 'VER_DOCUMENTO';

  static DOCUMENT_HISTORY = 'HISTORIAL-DOC';

  // Modelo de expediente
  static FE_SELECC_MODELO = 'FE_SELECC_MODELO';

  // Modelo de expediente
  static FE_SELECC_MODELO_TENDERDEF = 'FE_SELECC_MODELO_LICITACION';

  // Pantalla incial de la ficha, seleccion de modelo, general, reducida, etc
  static TIPO_FICHA = 'TIPO_FICHA';

  // Modelo de expediente
  static OFERTA_INFO = 'OFERTA_INFO';

  // EDIT_VAL_CRITERIO
  static EDIT_VAL_CRITERIO = 'EDIT_VAL_CRITERIO';

  static HELP_COMPANY = 'EMPRESAS';

  static EDIT_COMPANY = 'EDIT_EMPRESA';

  static LICENSE_NEW = 'NUEVA_LICENCIA';

  static VER_DOC_PRESENTADA = 'VER_DOC_PRESENTADA';

  static HELP_INIT = 'INICIO';

  static HELP_TASKS = 'TAREAS';

  static MASSIVE_SIGNATURE = 'FD_MASIVA';

  static HELP_TASK = 'TAREA';

  static HELP_DOSSIER = 'EXPEDIENTES';

  static DOSSIER_DOCUMENTS = 'DOCUMENTOS';

  static SEARCH_DOCUMENTS = 'BUSCADOR_DOCUMENTOS';

  static DOSSIER_INFO = 'AREA_EXPEDIENTE';

  static DOSSIER_PROCEDURES = 'TRAMITES';

  static DOSSIER_PLANNING = 'PLANIFICACION';

  static DOSSIER_ACTIONS = 'ACCIONES_EXP';

  static DOSSIER_ACTIONS2 = 'OTRAS_ACCIONES';

  static DOSSIER_AUDIT = 'AUDITORIA_EXP';

  static AUDIT_TRAM = 'AUDITORIA_TRAM';

  static DOSSIER_COMUNICATIONS = 'COMUNICACIONES';

  static DOSSIER_COMUNICATIONS_INFO = 'COMUNICACIONES_INFO';

  static DOSSIER_CALENDAR = 'CALENDARIO_EXP';

  static ACTIONS_LIST = 'ACTIONS_LIST';

  static EXPENSE_MANAGEMENT = 'GESTION_GASTO_CONSULTA'; // ACCOUNTING

  static EXPENSE_DOCUMENT_TYPES = 'SELECT_TIPO_DOCUMENTO_CONTABLE';

  static VIEW_EXPENSE_DOCUMENT = 'VER_DOCUMENTO_CONTABLE'; //

  static POST_EXPENSE_DOCUMENT = 'CONTABILIZAR_DOCUMENTO_CONTABLE'; // ACCOUNTINGDOCUMENT

  static NEW_EXPENSE_DOCUMENT = 'CREAR_DOCUMENTO_CONTABLE'; // ACCOUNTINGDOCUMENT

  static VALIDATE_EXPENSE_DOCUMENT = 'VALIDAR_DOCUMENTO_CONTABLE'; // ACCOUNTINGDOCUMENT

  static EDIT_EXPENSE_DOCUMENT = 'EDIT_DOCUMENTO_CONTABLE'; // ACCOUNTINGDOCUMENT

  static EXPENSE_DOCUMENT = 'DOCUMENTO_CONTABLE'; // ACCOUNTINGDOCUMENT

  static EDIT_EXPENSEDOCUMENT_BUDGETACCOUNTLINE = 'EDIT_PARTIDA_DOCUMENTO_CONTABLE'; // Partida del coumento contable

  static EDIT_ENDORSEMENT = 'EDIT_ENDOSATARIO_ENDOSO'; // Editor del endosatario en le ficha de endoso

  static PROCUREMENTPROJECT_LOT_STATE_INFO_CONSULT = 'CONSULT_ESTADO_ACTUAL_LOTES'; // A pertura en modo consulta de la pantalla Estado actual de los lotes de un expediente de contratación

  static CONSULT_TENDERCLASSIFICATION = 'CONSULT_CLASIFICACION_OFERTAS_POR_LOTES';

  static REG_CONTRACT = 'REG_CONTRACTOS';

  static DOSSIER_RULES = 'CONTROL_EXPEDIENTES';

  static DOSSIER_CONTRACTS = 'CONTRATOS';

  static CALENDAR = 'CALENDARIO';

  static CREATE_DOSSIER = 'CREACION_FICHA_EXPEDIENTE';

  static CREATE_LOT = 'CREACION_LOTE'; static REPORT = 'INFORMES';
  static REPORT_CONF_INFORME = 'CONF_INFORME';

  static GENERAL_HELP = 'AYUDA_GENERAL';

  static CONTROL_PANEL = 'PANEL_CONTROL';

  static LOGS = 'LOGS';

  static SUBSTITUTIONS = 'SUPLENCIAS';

  static EDIT_SUBSTITUTIONS = 'MTO_SUPLENCIAS';

  static INBOXS = 'BUZONES';

  static EDIT_INBOX = 'MTO_BUZONES';
  static USERS: 'USUARIOS';
  static EDIT_USER: 'MTO_USUARIOS';

  static ORGS: 'ORGANISMOS';
  static EDIT_ORGS: 'MTO_ORGANISMOS';
  static STATISTICS = 'MONITORIZACION';

  static AUDIT = 'AUDITORIA_SISTEMA';

  static LICENSE = 'LICENCIA';

  static ACTIONS = 'ACCIONES_SISTEMA';

  static CREATE_ACTIONS = 'CREA_ACCION';

  static SERVICES = 'SERVICIOS';

  static CACHE = 'CACHE';

  static VALIDATIONS = 'VALIDACIONES';

  static HELP = 'AYUDA';

  // static USERS = 'USUARIOS';

  static VIEW_USER = 'VER_USUARIO';

  static LOAD_USERS = 'CARGA_USUARIOS';

  static SESIONS = 'SESIONES';

  static MODEL_DOSSIER = 'MODELOS_FE';

  static CUSTOMFIELDS = 'CUSTOMFIELDS';

  static CRITERIADEF = 'CRITERIADEF';

  static CONFIGFILES = 'CONFIGFILES';

  static EDIT_CRITERIA_DEF = 'EDIT_CRITERIA_DEF';

  static EXECUTION_DIVISION = 'EXECUTION_DIVISION';

  static TENDER_DEFINITION = 'TENDER_DEFINITION';

  static ELEC_DOC_RECEIVED = 'DOCUMENTACION_ELECTRONICA_RECIBIDA';

  static ADD_TENDER = 'INCLUIR_OFERTA';

  static DECIPHER_TENDER = 'DESCIFRAR_OFERTA';

  static DATA_TENDER = 'DATOS_OFERTA';

  static CONTROL_PANEL_MODEL_DOSSIERS = 'PANEL_CONTROL_MODELOS_EXPEDIENTE';

  static CREATE_MODEL_DOSSIER = 'CREAR_MODELO_EXPEDIENTE';

  static ADMIN_FORMULAS = 'ADMIN_FORMULAS';

  static BIDDER_QUESTIONS = 'PREGUNTAS_LICIT';

  static USER_PREF_PANEL = 'USER_PREF_PANEL';

  static FACTURA = 'FACTURA';

  static EXPORTPROCESS = 'EXPORTACIONES';
  static EDIT_EXPORTPROCESS = 'EDITAR_EXPORTACION';
  static TENDER_MATERIAL = 'MATERIAL_OFERTA';
  static TENDER_MATERIAL_EDIT = 'EDITOR_MATERIAL_OFERTA';

  static FE_MATERIAL = 'MATERIAL_FE';
  static FE_MATERIAL_EDIT = 'EDITOR_MATERIAL_FE';

  static AWARD_MATERIAL = 'MATERIAL_ADJ';
  static AWARD_MATERIAL_EDIT = 'EDITOR_MATERIAL_ADJ';

  static CONTRACT_MATERIAL = 'MATERIAL_CONTRATO';
  static CONTRACT_MATERIAL_EDIT = 'EDITOR_MATERIAL_CONTRATO';

  static UNITPRICES_LIST = 'UNITPRICES_LIST';

  static TASK_LIST = 'TASK_LIST';
  static PROTOCOLS: 'PROTOCOLOS';
  static EDIT_PROTOCOL: 'MTO_PROTOCOLOS';
  static PROTOCOL_RULES: 'REGLAS_PROTOCOLO';

}

@Injectable()
export class HelpService extends BaseDirectiveObject {
  public translate: TranslateService;
  public locale: string;
  subscription: Subscription;
  private userService: UserService;

  constructor(
    public plycaService: PlycaDataService,
    public dialogService: DialogService,
    public uiService: UIService,
    protected store: Store<AppState>,
    protected configuration: Configuration,
    private waitService: WaitLoadingService
  ) {
    super();
    this.translate = ServiceLocator.injector.get(TranslateService);
    this.userService = ServiceLocator.injector.get(UserService);
  }

  search(searchText: string): Observable<any> {
    // return this.plycaService.getHelpContent(searchText);
    // return this.plycaService.query<any>(this.configuration.HELP_ELEMENT_SERVICE_URL);

    return this.plycaService.query<any>(
      this.configuration.HELP_ELEMENT_SERVICE_URL,
      {
        locale: this.translate.currentLang,
        search: searchText
      }
    );
  }

  searchByIndex(searchText: string): Observable<any> {
    // return this.plycaService.getHelpContent(searchText);
    // return this.plycaService.query<any>(this.configuration.HELP_ELEMENT_SERVICE_URL);

    return this.plycaService.query<any>(
      this.configuration.HELP_ELEMENT_SERVICE_URL,
      {
        locale: this.translate.currentLang,
        search: searchText,
        index: 'true'
      }
    );
  }

  searchByForm(searchText: string, contextObjects?: Array<any>): Observable<any> {
    if (contextObjects) {
      let labels = this.getLabelsByObject(contextObjects);
      searchText = searchText + ' ' + labels.join(' ');
    }
    return this.plycaService.query<any>(
      this.configuration.HELP_ELEMENT_SERVICE_URL,
      {
        locale: this.translate.currentLang,
        search: 'FLD_' + searchText.replace('.json', ''),
        formFields: 'true'
      }
    );
  }

  openSearchDialog(searchText: string, contextObjects?: Array<any>) {
    if (contextObjects) {
      let labels = this.getLabelsByObject(contextObjects);
      searchText = searchText + ' ' + labels.join(' ');
    }
    this.subscribe(this.search(searchText), result => {
      if (result.content) {
        let config: DynamicDialogConfig = {
          header: this.translate.instant('General.search.results'),
          width: '50%',
          style: { overflow: 'scroll', 'max-height': '80%' }
        };
        config['searchTags'] = [searchText];
        config['groupedHelp'] = this.groupHelp(result.content);

        return this.dialogService.open(HelpElementResultComponent, config);
      } else {
        return of('NO_RESULT');
      }
    });
  }

  getLabelsByObject(objArray: Array<any>): Array<string> {
    let labels: Array<string> = [];
    objArray.forEach(obj => {
      try {
        labels.push(
          'D_' +
          getSimpleIdentifierFromString(
            obj.documentClass.abbreviation
          )
        );
      } catch (ex) { }

      try {
        labels.push(
          'P_' +
          getSimpleIdentifierFromString(
            obj.type.identifier
          )
        );
      } catch (ex) { }

      try {
        labels.push(
          'VN_' +
          getSimpleIdentifierFromString(
            obj.applicableLegislation.identifier
          )
        );
      } catch (ex) { }
    })

    return labels;
  }

  getContextHelpObservable(search: any): Observable<any> {
    try {
      if (search) {
        /*si es un array de strings*/
        if (search instanceof Array) {
          return this.storeContextHelpTagsElements(search);
        } else if (typeof search === 'object') {
          // PREPARADO PARA REGLA O TAREA
          let task: TaskDTO = search;
          let labels: Array<string> = [];
          labels.push(HelpType.HELP_TASK); // confirmar
          if (search.identifier.startsWith('RULE')) {
            labels.push(search.name);
          } else {
            labels.push(this.getPlycaTaskId(task));
            try {
              labels.push(search.procedure.definition.identifier);
            } catch (ex) { }
          }
          labels.push(task.workType);
          try {
            labels.push(
              'D_' +
              getSimpleIdentifierFromString(
                task.division.documentClass.abbreviation
              )
            );
          } catch (ex) { }

          try {
            labels.push(
              'P_' +
              getSimpleIdentifierFromString(
                task.division.procedure.identifier
              )
            );
          } catch (ex) { }

          try {
            labels.push(
              'VN_' +
              getSimpleIdentifierFromString(
                task.division.project.applicableLegislation.identifier
              )
            );
          } catch (ex) { }

          if (task.taskData) {
            let phase = task.taskData.find(v => v.name === 'FASE');
            if (phase) {
              labels.push('F_' + phase.value);
            }
            let tDoc = task.taskData.find(v => v.name === 'TIPO_DOCUMENTO');
            if (tDoc) {
              labels.push('DOC_' + tDoc.value);
            }
            let action = task.taskData.find(v => v.name === 'ACCION');
            if (action) {
              labels.push(('ACC_' + action.value.replace('__', '')).replace('__', '_'));
            }
          }
          return this.storeContextHelpTagsElements(labels);
        } /*sis es un texto*/ else {
          let element: Array<string> = [];
          element.push(search);
          return this.storeContextHelpTagsElements(element);
        }
      } else {
        return of(true);
      }
    } catch (e) {
      console.log(e);
    }
  }
  showContextHelpObservable(search: any): Observable<any> {
    try {
      if (search) {
        /*si es un array de strings*/
        if (search instanceof Array) {
          return this.storeContextHelpTagsElements(search);
        } else if (typeof search === 'object') {
          // PREPARADO PARA REGLA O TAREA
          let task: TaskDTO = search;
          let labels: Array<string> = [];
          labels.push(HelpType.HELP_TASK); // confirmar
          if (search.identifier.startsWith('RULE')) {
            labels.push(search.name);
          } else {
            labels.push(this.getPlycaTaskId(task));
            try {
              labels.push(search.procedure.definition.identifier);
            } catch (ex) { }
          }
          labels.push(task.workType);
          try {
            labels.push(
              'D_' +
              getSimpleIdentifierFromString(
                task.division.documentClass.abbreviation
              )
            );
          } catch (ex) { }

          try {
            labels.push(
              'P_' +
              getSimpleIdentifierFromString(
                task.division.procedure.identifier
              )
            );
          } catch (ex) { }

          try {
            labels.push(
              'VN_' +
              getSimpleIdentifierFromString(
                task.division.project.applicableLegislation.identifier
              )
            );
          } catch (ex) { }

          if (task.taskData) {
            let phase = task.taskData.find(v => v.name === 'FASE');
            if (phase) {
              labels.push('F_' + phase.value);
            }
            let tDoc = task.taskData.find(v => v.name === 'TIPO_DOCUMENTO');
            if (tDoc) {
              labels.push('DOC_' + tDoc.value);
            }
            let action = task.taskData.find(v => v.name === 'ACCION');
            if (action) {
              labels.push(('ACC_' + action.value.replace('__', '')).replace('__', '_'));
            }
          }
          return this.storeContextHelpTagsElements(labels);
        } /*sis es un texto*/ else {
          let element: Array<string> = [];
          element.push(search);
          return this.storeContextHelpTagsElements(element);
        }
      } else {
        return of(true);
      }
    } catch (e) {
      console.log(e);
    }
  }

  getStoreTagsObservable(): Observable<string[]> {

    return this.store
      .select('contextHelp')
      .pipe(take(1),
        map((help: ContextHelp) => {
          return help.searchTags ? help.searchTags : [];
        }))


  }

  getPlycaTaskId(task: TaskDTO): string {
    let result: string;
    if (task) {
      let taskId = task.plycaTaskId.replace(/[0-9]/g, '');
      result = taskId;
      if (task.procedure && task.procedure.definition) {
        let procedureId = task.procedure.definition.identifier;
        result = taskId + '_' + procedureId;
      }
    }

    return result;
  }


  searchContextHelpTags(search: Array<string>): Observable<any> {
    console.log('//////////////storeContextHelp', search);
    let searchText = search ? search.join(' ') : undefined;

    return this.search(searchText)
      .pipe(

        map(
          (help: HelpDTO) => {
            let contextHelp = [];
            if (help && help.content) {
              contextHelp = help.content;
              console.log('contextHelp', contextHelp);
            }
            return contextHelp
            // this.store.dispatch(SET_CONTEXTHELP({ context: new ContextHelp(search, contextHelp) }))
          })
      );
  }
  storeContextHelpTagsElements(search: Array<string>): Observable<any> {

    let contextHelp = [];

    this.store.dispatch(SET_CONTEXTHELP({ context: new ContextHelp(search, contextHelp) }))
    return of(contextHelp)
  }

  clearContextHelp() {
    console.log('#############################', this.store);
    this.store.dispatch(DELETE_CONTEXTHELP());
  }

  showHelpElementInDialog(id: string) {
    this.waitService.startWaiting();

    this.subscribe(
      this.plycaService
        .get<HelpElementDTO>(this.configuration.HELP_ELEMENT_SERVICE_URL, id)
        .pipe(

          tap((help: HelpElementDTO) => {
            if (help) {
              let helpContent = '<div class="ql-snow"><div class="ql-editor">' + help.content + '</div></div>';
              this.uiService.showContent(helpContent, help.shortDesc, undefined, true);
            } else {
              console.log('NO ENCONTRADA ELEMENTO DE AYUDA CON ID: ' + id);
            }
          }),

          catchError(
            (err) => {
              console.log(err);
              return of(true)
            }
          ), finalize(() => this.waitService.cancelWaiting())
        )
    );
  }

  test(err?: any) { }

  groupHelp(helpElements: Array<HelpElementDTO>) {
    let groupedHelp = [];
    if (helpElements) {
      // ORDENAR LOS CONTENIDOS DE AYUDA DEL GRUPO, se ordena previamente el resultado y así queda todo ordenado

      helpElements.sort((a, b) => {

        // (a.name < b.name) ? 1 : ((b.name < a.name) ? -1 : 0)
        let name1 = this.uiService.normalizeString(a.name);
        let name2 = this.uiService.normalizeString(b.name);


        if (name1 < name2) {
          return -1;
        } else if (name1 > name2) {
          return 1;
        } else {
          return 0;
        }
      });

      helpElements.forEach(help => {
        // Si no tiene tipo, se asigna uno por defecto
        if (!help.type) {
          help.type = HelpElementType.AYUDA;
        }
        let group = groupedHelp.find(el => el.groupId === help.type);
        if (!group) {
          group = { groupId: help.type, helpElements: [] };
          groupedHelp.push(group);
        }
        group['helpElements'].push(help);
      });
    }
    // ORDENAR LOS GRUPOS DE AYUDA (AYUDA LA ULTIMA PESTANNA)
    groupedHelp = groupedHelp.sort((el1, el2) => {
      let idxEl1 = this.getIdFromGroupId(el1.groupId);
      let idxEl2 = this.getIdFromGroupId(el2.groupId);
      return idxEl1 < idxEl2 ? -1 : idxEl1 > idxEl2 ? 1 : 0;
    });


    return groupedHelp;
  }

  private getIdFromGroupId(groupId: string): number {
    switch (groupId) {
      case HelpElementType.NOTA_INTERNA:
        return 0;
      case HelpElementType.CASO_PRACTICO:
        return 1;
      case HelpElementType.AYUDA:
        return 2;
      case HelpElementType.NORMATIVA:
        return 3;
    }
  }

  public generateInternalLinks(elem: ElementRef): Observable<any> {
    return this.generateInternalLinksDialog(elem, null);
  }
  // Método que sustituye los enlaces a elementos internos de la ayuda (delimitados por @)
  public generateInternalLinksDialog(elem: ElementRef, ref: DynamicDialogRef): Observable<any> {

    let anchors = elem.nativeElement.querySelectorAll('a');
    let anchorNodes = Array.prototype.slice.call(anchors, 0); // patch: IE no permite forEach de un nodeList
    let allQueriesObs = new Array<Observable<any>>();
    anchorNodes.forEach((anchor: HTMLAnchorElement) => {
      let parent = this;


      // Enlace a otro contenido de ayuda
      if (anchor.href && anchor.href.indexOf('/@') > 0 && anchor.href.endsWith('@')) {
        let helpId = anchor.href;

        helpId = helpId.substring(helpId.indexOf('/@') + 2, helpId.length - 1);
        if (helpId && helpId != null && helpId !== '') {


          // 1) Comprobar si el usuario tiene acceso al contenido del enlace

          // this.waitService.startWaiting(); -- no se puede poner capa de espera por que cancela la carga de la pantalla de ayuda
          let obs: Observable<any>;
          obs = this.plycaService
            .get<HelpElementDTO>(this.configuration.HELP_ELEMENT_SERVICE_URL, helpId)
            // .pipe(catchError(error => test()))
            .pipe(tap(
              (help: HelpElementDTO) => {
                if (help) {

                  // 2a) Si no existen perfiles de acceso al contenido del enlace
                  if (!help.profiles || help.profiles.length === 0
                    || (this.userService.hasRoles(help.profiles.join(', ')))) {


                    anchor.href = 'javascript:void(0)';
                    anchor.removeAttribute('target');
                    anchor.addEventListener('click', function () {
                      if (ref && ref != null) {
                        ref.close();
                      }
                      parent.showHelpElementInDialog(helpId)
                    });

                  } else {
                    // 2a) Si  existen perfiles de acceso al contenido del enlace
                    // se deja el texto del enlace sin acción asociada.


                    anchor.href = 'javascript:void(0)';
                    anchor.removeAttribute('target');
                    anchor.setAttribute('disabled', 'disabled');
                    anchor.setAttribute('style', 'text-decoration: none;color: inherit;cursor: none;');
                  }

                }
              }


            ), catchError((err) => {
              console.error
                ('Elemento de ayuda no encontrado: ' + helpId);
              return of({});
            }));

          allQueriesObs.push(obs);

          /*
          anchor.addEventListener('click', function () {
            if (ref && ref != null) {
              ref.close();
            }
            parent.showHelpElementInDialog(helpId)
          });*/
        }


        // Enlace http, se revisan los parámetro para ver si hay que sustuir el parámetro de usuario
      } else if (anchor.href && anchor.href.indexOf('$PARAMUSER$') > 0) {
        anchor.href = anchor.href.replace('$PARAMUSER$', this.userService.getUser().identifier);

        console.log(anchor.href);
      }
    });

    let result: Observable<any>;
    if (allQueriesObs && allQueriesObs.length > 0) {

      result = forkJoin(allQueriesObs);
    } else {
      result = of(true);
    }

    return result.pipe(finalize(() => this.waitService.cancelWaiting()));


  }

}
